function LoadView(view) {
  return () =>
    import(
      /* webpackChunkName: "view-[request]" */ `@/pages/subpage/nonstop/${view}.vue`
    );
}

const nonstopRoutes = [
  /* 주차 편의 서비스 */

  // 무정차 정산 안내
  {
    path: '/nonstop/info',
    name: 'nonstopInfo',
    component: LoadView('nonstopInfo'),
    meta: {
      category: ['주차 편의 서비스', '무정차 정산 안내'],
      isLnb: true,
    },
  },

  // 무정차 정산 신청
  {
    path: '/nonstop/apply',
    name: 'nonstopApply',
    component: LoadView('nonstopApply'),
    meta: {
      category: ['주차 편의 서비스', '무정차 정산 신청'],
      empcategory: ['USR', 'ADMIN'],
      isLnb: true,
    },
  },
];

export default nonstopRoutes;
